import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {Region} from "@/modules/base/entity";
import {Team} from "@/modules/team/entity";
import {AfterCreateGameEvent} from "@/modules/base/events/AfterCreateGameEvent";
import YouthPlayerFactory from "@/modules/youth/services/factories/YouthPlayerFactory";
import {RegionEnum} from "@/modules/base/enums";

@injectable()
export class YouthPlayerSeederEventSubscriber implements EventSubscriber {
  constructor(
    @inject(YouthPlayerFactory) private youthPlayerFactory: YouthPlayerFactory
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: AfterCreateGameEvent, callback: this.onAfterCreateGame},
    ];
  }

  async onAfterCreateGame(event: AfterCreateGameEvent): Promise<void> {
    const team = await Team.current();

    const en = await Region.findOneOrFail({
      where: {name: RegionEnum.EU},
    });

    await this.youthPlayerFactory.generate(en, 2, player => {
      player.revelation = 100;
      player.team = team;
    });

    const sa = await Region.findOneOrFail({
      where: {name: RegionEnum.SA},
    });

    await this.youthPlayerFactory.generate(sa, 2, player => player.team = team);

    return;

    const na = await Region.findOneOrFail({
      where: {name: RegionEnum.NA},
    });

    await this.youthPlayerFactory.generate(na, 6, player => player.team = team);
  }
}